<template>
  <header class="bg-header flex justify-between h-20 min-h-[80px]">
    <div class="flex items-center">
      <a :href="config.public.GSNurl" target="_blank">
        <Logo container-class="pl-12" />
      </a>
    </div>
    <div class="flex item-center gap-6 pr-12">
      <div class="relative flex items-center cursor-pointer" @click="navigateToRoute('/cart')">
        <img :src="cart" alt="cart" class="w-6" />
        <div class="absolute top-5 -right-3.5" >
          <ClientOnly>
            <Badge v-if="cartNumber > 0" class="w-5 h-5 flex justify-center items-center text-white bg-colorRed hover:bg-colorRed">
              <p class="flex justify-center items-center">{{ cartNumber  }}</p>
            </Badge>
            
          </ClientOnly>
  
        </div>
      </div>
      <!-- <HeaderLanguageToggle /> -->
      <HeaderAvatar />
      
    </div>
  </header>
</template>
<script setup lang="ts">

import cart from "@/assets/icons/header/cart.svg";
import { useUserInfoStore } from '~/stores/storeUserInfo'
const { useCartRetrieve } = useCartSync();
import { nextTick } from 'vue';
// UI Components
import { Badge } from '@/components/ui/badge'

// cartstore
const cartStore = useCartState()
const userInfoStore = useUserInfoStore()
const authStore = useAuthStore()
const config = useRuntimeConfig()
// 跳轉到 cart 頁面
const router = useRouter()
const route = useRoute()

const cartNumber = computed(() => {
  // 加總商品數量
  let total = 0
  cartStore.orderItems.forEach(item => {
    total += Number(item.subQty)
  })
  return total;
});


const navigateToRoute = async (path: string) => {
  try {
    // Only navigate if we're not already on the route
    if (route.path !== path) {
      await router.push(path)
    }
  } catch (error) {
    console.error(`Navigation failed: ${error}`)
  }
}



const token = useCookie<string>('token')
onMounted(async() => {
  useCartRetrieve(cartStore)
  try{
    if(!userInfoStore.userInfo){
      await userInfoStore.setUserInfo(token.value)
      
    }
  }catch(error:any){
    if(error.message === 'Unauthenticated') {
      authStore.signOut()
    }
  }

})
</script>
